<template>
    <div>
        <div
            data-testid="grid-root"
            class="grid gap-6 py-3 px-6 w-full"
            :style="{ gridTemplateColumns: gridColumnsWidth }"
            :key="`addon-row-skeleton-${row}`"
            v-for="row in nRows"
        >
            <skeleton-loading
                class="h-10"
                :class="columnWidth()"
                :key="col"
                v-for="col in nColumns"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    /**
     * Skeleton loader, substitute for a list of rows in a grid.
     */
    import SkeletonLoading from '@/components/loading/SkeletonLoading.vue';

    interface Props {
        nColumns: number;
        nRows: number;
        gridColumnsWidth: string; // e.g. "1fr 1fr 1fr"
    }

    const props = defineProps<Props>();

    const columnWidth = () => {
        // Randomize width for skeleton loading bars for visual interest.
        if (props.gridColumnsWidth || Math.random() > 0.7) {
            return 'w-full';
        }

        const widths = ['w-[40%]', 'w-[50%]', 'w-[60%]', 'w-[70%]', 'w-[80%]', 'w-[90%]'];
        return widths[Math.floor(Math.random() * widths.length)];
    };
</script>
